import { SHOOB_DAY_SUFFIX } from './shoob-day'
import dayOptionLabel from './day-option-label'

describe('dayOptionLabel', () => {
  it('appends the studio name for a Shoob day, regardless of school', () => {
    expect(dayOptionLabel(`2026-10-03${SHOOB_DAY_SUFFIX}`, { name: 'Weber Institute' }))
      .toBe('October, 3 @ Shoob Photo Studio')
  })

  it('appends the school name for an on-location day', () => {
    expect(dayOptionLabel('2026-10-05', { name: 'Weber Institute' }))
      .toBe('October, 5 @ Weber Institute')
  })

  it('falls back to the bare date when no school is available', () => {
    expect(dayOptionLabel('2026-10-05', null)).toBe('October, 5')
    expect(dayOptionLabel('2026-10-05', {})).toBe('October, 5')
  })
})
